import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../modules/auth/services/token-storage.service';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  loading: boolean;

  constructor(
    private router: Router,
    private Auth: TokenStorageService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMsg = '';
          if (error.error instanceof ErrorEvent) {
            console.log('This is a client side error');
            errorMsg = `Erreur: ${error.error.message}`;
          } else {
            console.log('This is a server side error');
            console.log(error);
            errorMsg = `Code d'erreur: ${error.status}, Message: ${JSON.stringify(error.error.error)}`;

            console.log(`${JSON.stringify(error)}`);
          }

          let title = '';
          if (error.error && error.error.error) {
            title = `${JSON.stringify(error.error.error)}`;
          } else {
            switch (error.status) {
              case 0:
              case 415:
                title = "Un problème est survenu, prière de vérifier votre connexion internet puis cliquer sur le bouton pour rafraîchir";
                break;
              case 404:
                title = "Entité introuvable";
                break;
              case 413:
                title = "Le volume du fichier dépasse la limite de la bande passante, veuillez contacter votre administrateur système pour régler la situation";
                break;
              default:
                title = "Une erreur est survenue";
            }
          }

          Swal.fire({
            position: 'center',
            icon: 'error',
            title: `<strong>${title}</strong>`,
            confirmButtonText: error.status === 415 || error.status === 0 ? 'Rafraîchir' : 'OK',
            timer: 30000,
          }).then((result) => {
            if ((error.status === 415 || error.status === 0) && result.value) {
              this.reloadPage();
            }
          }).catch(() => {
            Swal.fire('Échec!', 'Une erreur est survenue.');
          });

          return throwError(errorMsg);
        })
      );
  }

  reloadPage() {
    setTimeout(() => window.location.reload());
  }
}
